<template>
  <div>
    <div class="box"  style="margin-top:20px">
      <div class="box-header">
        <h3>IDC위치 추가</h3>
        <small>IDC 위치를 추가 합니다.</small>
      </div>
      <div class="box-body">
        <form action="">
          <div class="form-group row">
            <label class="col-2 form-control-label">
              <span class="ess">위치 이름</span>
            </label>
            <div class="col-10 pt-2">
              <input type="text"  v-model="item.locationName" class="form-control form-control-success">
            </div>
          </div>
          <div class="form-group row">
            <label class="col-2 form-control-label">
              <span class="ess">위치 코드</span>
            </label>
            <div class="col-10 pt-2">
              <input type="text"  v-model="item.locationCode" class="form-control form-control-success">
            </div>
          </div>
        </form>
      </div>
    </div>



    <div class="btn-wrap justify-content-center mt-30 mb-40">
      <button class="btn btn-lg blue"  @click="addLocation()" :disabled="!(item.locationCode && item.locationName)">완료
        <i class="icon-check ml-5" ></i>
      </button>
    </div>
  </div>
</template>

<script>
import Dropdown from "@/components/Dropdown.vue"
export default {
  components: {Dropdown},
  props: {
    data: Object,
  },
  data(){
    return {
      item: {
        locationName: null,
        locationCode: null
      },
    }
  },
  computed: {
  },
  mounted(){
    setTimeout(()=>{
      $('.scroll-wrap').mCustomScrollbar({
        theme: 'dark-thick',
      });

    },500)

  },
  updated(){

  },
  methods: {
    addLocation(){
      var that = this;
      var o = this.item;
      o.parentCode = this.data.data.locationCode;
      o.isCustom = 1;
      o.isDeleteYN = 'N';
      o.locale = this.data.data.locale;

      this.$http.post('/api/private/location', o).then((result) => {
        // this.$toast.success('입실 완료 되었습니다.');
        this.$store.dispatch('location/deleteAllLocation');
        let location = that.$store.getters['location/location'];
        setTimeout(()=>{
          that.noti('저장되었습니다.', 'success');
          that.closeModal();
          that.$router.go(0);
        },1000)
      }).catch((e) =>{
        console.log(e);
      })
    },
  }
}
</script>

<style>

</style>
